// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InsideMapsProductOfferingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InsideMapsProductOfferingsQuery = { __typename?: 'Query', productOfferings: { __typename?: 'ProductOfferingsPageResult', entities: Array<{ __typename?: 'ProductOffering', id: string, name: string, displayName: string, displayCode?: string | null | undefined, planPackage: { __typename?: 'PlanPackage', id: string, name: string, displayName: string }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, displayName: string }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, displayName: string }, readyPlanInsideMapsConfig?: { __typename?: 'ReadyPlanInsideMapsConfig', id: string, insideMapsConfig?: string | null | undefined, activeVersion?: { __typename?: 'ReadyPlanInsideMapsConfigVersion', id: string } | null | undefined, draftVersion?: { __typename?: 'ReadyPlanInsideMapsConfigVersion', id: string } | null | undefined } | null | undefined }> } };

export type InsideMapsMaterialVariantsQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type InsideMapsMaterialVariantsQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, location: { __typename?: 'Location', id: string, name: string, path?: string | null | undefined, room?: { __typename?: 'Location', id: string, name: string } | null | undefined }, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, displayName: string } } } } | null | undefined }> } };

export type InsideMapsTliByDesignPackageQueryVariables = Types.Exact<{
  dpId?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type InsideMapsTliByDesignPackageQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, displayName: string } } } } | null | undefined }> } };

export type InsideMapsDesignPackageMaterialsQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type InsideMapsDesignPackageMaterialsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, displayName: string } } } } | null | undefined }> }> } };


export const InsideMapsProductOfferingsDocument = gql`
    query InsideMapsProductOfferings {
  productOfferings(page: {limit: 500, offset: 0}) {
    entities {
      id
      name
      displayName
      displayCode
      planPackage {
        id
        name
        displayName
      }
      interiorDesignPackage {
        id
        name
        displayName
      }
      exteriorDesignPackage {
        id
        name
        displayName
      }
      readyPlanInsideMapsConfig {
        id
        insideMapsConfig
        activeVersion {
          id
        }
        draftVersion {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useInsideMapsProductOfferingsQuery__
 *
 * To run a query within a React component, call `useInsideMapsProductOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsideMapsProductOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsideMapsProductOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsideMapsProductOfferingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>(InsideMapsProductOfferingsDocument, options);
      }
export function useInsideMapsProductOfferingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>(InsideMapsProductOfferingsDocument, options);
        }
// @ts-ignore
export function useInsideMapsProductOfferingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>;
export function useInsideMapsProductOfferingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsProductOfferingsQuery | undefined, InsideMapsProductOfferingsQueryVariables>;
export function useInsideMapsProductOfferingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>(InsideMapsProductOfferingsDocument, options);
        }
export type InsideMapsProductOfferingsQueryHookResult = ReturnType<typeof useInsideMapsProductOfferingsQuery>;
export type InsideMapsProductOfferingsLazyQueryHookResult = ReturnType<typeof useInsideMapsProductOfferingsLazyQuery>;
export type InsideMapsProductOfferingsSuspenseQueryHookResult = ReturnType<typeof useInsideMapsProductOfferingsSuspenseQuery>;
export type InsideMapsProductOfferingsQueryResult = Apollo.QueryResult<InsideMapsProductOfferingsQuery, InsideMapsProductOfferingsQueryVariables>;
export const InsideMapsMaterialVariantsDocument = gql`
    query InsideMapsMaterialVariants($productOfferingId: ID!, $first: Int, $offset: Int) {
  takeoffLineItemsPage(
    filter: {readyPlan: [$productOfferingId]}
    first: $first
    offset: $offset
  ) {
    items {
      id
      location {
        id
        name
        path
        room {
          id
          name
        }
      }
      materialVariant {
        id
        displayName
        modelNumber
        manufacturerUrl
        featuredImage {
          id
          asset {
            id
            downloadUrl
          }
        }
        listing {
          id
          name
          brand {
            id
            name
          }
          item {
            id
            costCode {
              id
              number
              displayName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInsideMapsMaterialVariantsQuery__
 *
 * To run a query within a React component, call `useInsideMapsMaterialVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsideMapsMaterialVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsideMapsMaterialVariantsQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useInsideMapsMaterialVariantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables> & ({ variables: InsideMapsMaterialVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>(InsideMapsMaterialVariantsDocument, options);
      }
export function useInsideMapsMaterialVariantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>(InsideMapsMaterialVariantsDocument, options);
        }
// @ts-ignore
export function useInsideMapsMaterialVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>;
export function useInsideMapsMaterialVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsMaterialVariantsQuery | undefined, InsideMapsMaterialVariantsQueryVariables>;
export function useInsideMapsMaterialVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>(InsideMapsMaterialVariantsDocument, options);
        }
export type InsideMapsMaterialVariantsQueryHookResult = ReturnType<typeof useInsideMapsMaterialVariantsQuery>;
export type InsideMapsMaterialVariantsLazyQueryHookResult = ReturnType<typeof useInsideMapsMaterialVariantsLazyQuery>;
export type InsideMapsMaterialVariantsSuspenseQueryHookResult = ReturnType<typeof useInsideMapsMaterialVariantsSuspenseQuery>;
export type InsideMapsMaterialVariantsQueryResult = Apollo.QueryResult<InsideMapsMaterialVariantsQuery, InsideMapsMaterialVariantsQueryVariables>;
export const InsideMapsTliByDesignPackageDocument = gql`
    query InsideMapsTliByDesignPackage($dpId: [ID!], $versionId: ID) {
  takeoffLineItemsPage(
    filter: {readyPlan: $dpId, designPackageType: [REGULAR_PRODUCT_CARD, RPO_SHADOW_PRODUCT_CARD]}
    versionId: $versionId
    first: 4000
  ) {
    items {
      id
      materialVariant {
        id
        displayName
        modelNumber
        manufacturerUrl
        featuredImage {
          id
          asset {
            id
            downloadUrl
          }
        }
        listing {
          id
          name
          brand {
            id
            name
          }
          item {
            id
            costCode {
              id
              number
              displayName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInsideMapsTliByDesignPackageQuery__
 *
 * To run a query within a React component, call `useInsideMapsTliByDesignPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsideMapsTliByDesignPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsideMapsTliByDesignPackageQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useInsideMapsTliByDesignPackageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>(InsideMapsTliByDesignPackageDocument, options);
      }
export function useInsideMapsTliByDesignPackageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>(InsideMapsTliByDesignPackageDocument, options);
        }
// @ts-ignore
export function useInsideMapsTliByDesignPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>;
export function useInsideMapsTliByDesignPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsTliByDesignPackageQuery | undefined, InsideMapsTliByDesignPackageQueryVariables>;
export function useInsideMapsTliByDesignPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>(InsideMapsTliByDesignPackageDocument, options);
        }
export type InsideMapsTliByDesignPackageQueryHookResult = ReturnType<typeof useInsideMapsTliByDesignPackageQuery>;
export type InsideMapsTliByDesignPackageLazyQueryHookResult = ReturnType<typeof useInsideMapsTliByDesignPackageLazyQuery>;
export type InsideMapsTliByDesignPackageSuspenseQueryHookResult = ReturnType<typeof useInsideMapsTliByDesignPackageSuspenseQuery>;
export type InsideMapsTliByDesignPackageQueryResult = Apollo.QueryResult<InsideMapsTliByDesignPackageQuery, InsideMapsTliByDesignPackageQueryVariables>;
export const InsideMapsDesignPackageMaterialsDocument = gql`
    query InsideMapsDesignPackageMaterials($dpId: ID!, $rpavId: ID) {
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    optionGroups {
      id
      name
      options {
        id
        name
        materialVariant {
          id
          displayName
          modelNumber
          manufacturerUrl
          featuredImage {
            id
            asset {
              id
              downloadUrl
            }
          }
          listing {
            id
            name
            brand {
              id
              name
            }
            item {
              id
              costCode {
                id
                number
                displayName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInsideMapsDesignPackageMaterialsQuery__
 *
 * To run a query within a React component, call `useInsideMapsDesignPackageMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsideMapsDesignPackageMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsideMapsDesignPackageMaterialsQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useInsideMapsDesignPackageMaterialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables> & ({ variables: InsideMapsDesignPackageMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>(InsideMapsDesignPackageMaterialsDocument, options);
      }
export function useInsideMapsDesignPackageMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>(InsideMapsDesignPackageMaterialsDocument, options);
        }
// @ts-ignore
export function useInsideMapsDesignPackageMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>;
export function useInsideMapsDesignPackageMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InsideMapsDesignPackageMaterialsQuery | undefined, InsideMapsDesignPackageMaterialsQueryVariables>;
export function useInsideMapsDesignPackageMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>(InsideMapsDesignPackageMaterialsDocument, options);
        }
export type InsideMapsDesignPackageMaterialsQueryHookResult = ReturnType<typeof useInsideMapsDesignPackageMaterialsQuery>;
export type InsideMapsDesignPackageMaterialsLazyQueryHookResult = ReturnType<typeof useInsideMapsDesignPackageMaterialsLazyQuery>;
export type InsideMapsDesignPackageMaterialsSuspenseQueryHookResult = ReturnType<typeof useInsideMapsDesignPackageMaterialsSuspenseQuery>;
export type InsideMapsDesignPackageMaterialsQueryResult = Apollo.QueryResult<InsideMapsDesignPackageMaterialsQuery, InsideMapsDesignPackageMaterialsQueryVariables>;